
// import React from "react";
// import { useNavigate } from "react-router-dom";

// const services = [
//   {
//     title: "HALI YIKAMA",
//     headingImage: "/images/headings/15.png",
//     image: "/images/services/hali.png",
//     description:
//       "Halı yıkama işleminde, evinizin hijyenini sağlamak ve halılarınızı en uygun yöntemlerle temiz tutmak için profesyonel ekipmanlar kullanılmaktadır. Derinlemesine temizlik sağlayan özel tekniklerle halılarınız ilk günkü parlaklığına kavuşur!",
//     path: "/hali-yikama",
//   },
//   {
//     title: "YORGAN YIKAMA",
//     headingImage: "/images/headings/7.png",
//     image: "/images/services/yorgan.png",
//     description:
//       "Yorgan ve battaniye yıkama, kış aylarında bakteri oluşumunu engellemek açısından çok büyük önem taşır. Profesyonel sistemler ve doğal ürünlerle yapılan yıkama işlemi, yorganlarınızın hem temiz hem de sağlıklı kullanılmasını sağlar.",
//     path: "/yorgan-yikama",
//   },
//   {
//     title: "KURU TEMİZLEME",
//     headingImage: "/images/headings/13.png",
//     image: "/images/services/kuru.png",
//     description:
//       "Kuru temizleme işlemi, çabuk deforme olan hassas kumaşlar için idealdir. Leke çıkarıcı ve formunu koruyucu kimyasallarla yapılan işlemler sayesinde kıyafetlerinizin ömrü uzar ve hijyenik kalır.",
//     path: "/kuru-temizleme",
//   },
//   {
//     title: "KOLTUK YIKAMA",
//     headingImage: "/images/headings/5.png",
//     image: "/images/services/8.png",
//     description:
//       "Koltuk yıkama işlemi, yaşam alanlarınızdaki hijyen seviyesini yükseltir. Derinlemesine temizlik sağlayan makineler sayesinde koltuklarınız hem temiz hem de alerjenlerden arınmış olur.",
//     path: "/koltuk-yikama",
//   },
//   {
//     title: "YERİNDE YIKAMA",
//     headingImage: "/images/headings/10.png",
//     image: "/images/services/9.webp",
//     description:
//       "Yerinde yıkama hizmeti; halı, koltuk ve yatak gibi eşyalarınızın bulunduğu yerden alınmadan, özel makinelerle temizlenmesini sağlar. Hijyenik ortam sağlanırken zaman ve iş gücünden tasarruf edilir.",
//     path: "/yerinde-yikama",
//   },
//   {
//     title: "YATAK YIKAMA",
//     headingImage: "/images/headings/6.png",
//     image: "/images/services/yatak.png",
//     description:
//       "Yatak ve battaniye yıkama, kış aylarında bakteri oluşumunu engellemek açısından çok büyük önem taşır. Hijyenik yataklar için profesyonel ekipmanlar ve sağlığa uygun deterjanlarla hizmet verilir.",
//     path: "/yatak-yikama",
//   },
//   {
//     title: "PERDE YIKAMA",
//     headingImage: "/images/headings/8.png",
//     image: "/images/services/10.png",
//     description:
//       "Stor ve zebra perde yıkama işlemleri, evinizin havasını tazeler. Toz, kir ve bakterilerin tamamen arındırılması sağlanır. Perde türüne uygun yıkama teknikleriyle güvenli temizlik sunulur.",
//     path: "/stor-zebra-perde-yikama",
//   },
//   {
//     title: "HALI-OVERLOK",
//     headingImage: "/images/headings/11.png",
//     image: "/images/services/13.png",
//     description:
//       "Halı uçları ve overlik hizmetleri, yıpranan halıların daha estetik görünmesini sağlar. Kenar dikişleriyle halınızın uzun ömürlü kullanımı garanti altına alınır.",
//     path: "/hali-tamir-overlok",
//   },
//   {
//     title: "HALI-TAMİRİ",
//     headingImage: "/images/headings/12.png",
//     image: "/images/services/15.png",
//     description:
//       "Yırtılan halılar ve overlok hizmetleri, yıpranan zemin dokusunu onarmak için büyük önem taşır. Hasarlı bölgelerin profesyonelce onarımı sayesinde halınız tekrar kullanılabilir duruma gelir.",
//     path: "/hali-tamir-overlok",
//   },
// ];

// const ServicesGrid = () => {
//   const navigate = useNavigate();

//   return (
//     <section className="bg-[#f7f7d4] py-12 px-4">
//       <div className="bg-[#f7f7d4] py-10 px-4">
//         <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
//           {services.map((item, index) => (
//             <div
//               key={index}
//               className="bg-white p-4 rounded-xl border border-[#ccc] shadow-md cursor-pointer hover:shadow-lg transition"
//               onClick={() => navigate(item.path)}
//             >
//               {/* Üst başlık görseli */}
//               <div className="flex justify-center mb-3">
//                 <img
//                   src={item.headingImage}
//                   alt={item.title}
//                   className="h-[60px] object-contain"
//                 />
//               </div>

//               {/* Orta görsel */}
//               <div className="mb-4 rounded-md overflow-hidden border border-black/50">
//                 <img
//                   src={item.image}
//                   alt={item.title}
//                   className="w-full h-48 object-cover"
//                 />
//               </div>

//               {/* Açıklama */}
//               <p className="text-[15px] text-gray-900 leading-relaxed text-justify font-[500]">
//                 {item.description}
//               </p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ServicesGrid;
import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

const services = [
  {
    title: "Halı Yıkama",
    image: "/images/services/hali.png",
    description:
      "Halılarınız profesyonel makinelerde, antibakteriyel ürünlerle ve kumaş yapısına uygun özel yöntemlerle derinlemesine temizlenir.",
    path: "/hali-yikama",
  },
  {
    title: "Yorgan Yıkama",
    image: "/images/services/yorgan.png",
    description:
      "Yorgan ve battaniyeleriniz hijyenik yıkama sistemleriyle temizlenir, ferah ve sağlıklı kullanım için özenle teslim edilir.",
    path: "/yorgan-yikama",
  },
  {
    title: "Kuru Temizleme",
    image: "/images/services/kuru.png",
    description:
      "Hassas kumaşlarınız formunu kaybetmeden, özel temizleme teknikleriyle güvenle temizlenir ve kullanıma hazır hale getirilir.",
    path: "/kuru-temizleme",
  },
  {
    title: "Koltuk Yıkama",
    image: "/images/services/8.png",
    description:
      "Koltuklarınız yerinde profesyonel makinelerle temizlenir, kir, leke ve kötü kokulardan arındırılarak ferahlatılır.",
    path: "/koltuk-yikama",
  },
  {
    title: "Yerinde Yıkama",
    image: "/images/services/9.webp",
    description:
      "Halı, koltuk ve yatak gibi ürünleriniz adresinizde özel ekipmanlarla temizlenir, zamandan tasarruf sağlanır.",
    path: "/yerinde-yikama",
  },
  {
    title: "Yatak Yıkama",
    image: "/images/services/yatak.png",
    description:
      "Yataklarınız toz, akar ve bakterilerden arındırılarak daha hijyenik ve sağlıklı bir uyku ortamı oluşturulur.",
    path: "/yatak-yikama",
  },
  {
    title: "Perde Yıkama",
    image: "/images/services/10.png",
    description:
      "Stor ve zebra perdeleriniz türüne uygun yöntemlerle temizlenir, evinizin havası yenilenmiş bir görünüme kavuşur.",
    path: "/stor-zebra-perde-yikama",
  },
  {
    title: "Halı Overlok",
    image: "/images/services/13.png",
    description:
      "Yıpranan halı kenarları profesyonel overlok işlemiyle güçlendirilir, halınız daha estetik ve uzun ömürlü olur.",
    path: "/hali-tamir-overlok",
  },
  {
    title: "Halı Tamiri",
    image: "/images/services/15.png",
    description:
      "Hasarlı, sökülen veya yıpranan halılarınız uzman işlemle onarılır, yeniden kullanıma uygun hale getirilir.",
    path: "/hali-tamir-overlok",
  },
];

const ServicesGrid = () => {
  const navigate = useNavigate();

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#FFF9F3] via-[#F8EFE5] to-[#FFFDFB] px-4 py-14 md:py-20">
      <div className="pointer-events-none absolute -top-24 right-0 h-72 w-72 rounded-full bg-[#C18A4A]/10 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-0 h-72 w-72 rounded-full bg-[#0E2A47]/10 blur-3xl" />

      <div className="relative z-10 mx-auto max-w-screen-xl">
        <div className="mx-auto mb-12 max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-[#D8C2A8] bg-white/80 px-4 py-2 text-[11px] font-bold uppercase tracking-[2px] text-[#B07A3F] shadow-sm">
            <Sparkles size={14} />
            Profesyonel Hizmetler
          </span>

          <h2 className="mt-5 text-3xl font-black leading-tight text-[#0E2A47] md:text-5xl">
            Temizliğin Her Alanında
            <span className="block text-[#B07A3F]">Güvenilir Çözümler</span>
          </h2>

          <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-8 text-[#6A625A]">
            Halı, koltuk, perde, yorgan, yatak ve yerinde yıkama hizmetlerinde
            modern ekipmanlar, hijyenik ürünler ve uzman ekibimizle kaliteli
            temizlik sunuyoruz.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((item, index) => (
            <div
              key={index}
              onClick={() => navigate(item.path)}
              className="group cursor-pointer overflow-hidden rounded-[30px] border border-[#EADBCB] bg-white shadow-[0_12px_35px_rgba(0,0,0,0.05)] transition-all duration-300 hover:-translate-y-1 hover:border-[#C18A4A] hover:shadow-[0_20px_50px_rgba(0,0,0,0.1)]"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-[#0E2A47]/80 via-[#0E2A47]/20 to-transparent" />

                <div className="absolute bottom-5 left-5 right-5">
                  <h3 className="text-2xl font-black text-white drop-shadow">
                    {item.title}
                  </h3>
                </div>
              </div>

              <div className="space-y-5 p-6">
                <p className="text-[15px] leading-8 text-[#5F5750]">
                  {item.description}
                </p>

                <div className="flex items-center justify-between border-t border-[#EFE2D4] pt-5">
                  <span className="text-sm font-bold text-[#0E2A47]">
                    Detaylı Bilgi Al
                  </span>

                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#FFF4E8] text-[#B07A3F] transition-all duration-300 group-hover:bg-[#C18A4A] group-hover:text-white">
                    <ArrowRight size={18} />
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;